module.exports = __webpack_public_path__ + "img/image34.4fdfcd7f.png";